import { Component, EventEmitter, Injector, OnDestroy, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';
import { AssinaturaServiceProxy, CartaoCreditoDto, CreatePagamentoCustoAdicionalDto, CustoAdicionalMensalDto, CustoAdicionalMensalServiceProxy, EnderecoAssinaturaDto, TipoPagamentoEnum } from '@shared/service-proxies/service-proxies';
import { CartaoCreditoAuxiliarModel } from '@shared/model/cartao-credito-auxiliar.model';
import { MetodosPagamentosComponent } from '../metodos-pagamentos/metodos-pagamentos.component';
import { StringUtils } from '@shared/helpers/StringUtils';
import { finalize } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-view-custo-adicional',
  templateUrl: './view-custo-adicional.component.html',
  styleUrls: ['./view-custo-adicional.component.scss']
})

export class ViewCustoAdicionalComponent extends AppComponentBase implements OnDestroy {

  public custo: CustoAdicionalMensalDto
  public saving: boolean = false;
  protected pagamentoSelecionado: string;
  protected cartaoCredito: CartaoCreditoAuxiliarModel = new CartaoCreditoAuxiliarModel();
  protected endereco: EnderecoAssinaturaDto = new EnderecoAssinaturaDto();
  private createPagamento: CreatePagamentoCustoAdicionalDto = new CreatePagamentoCustoAdicionalDto();
  private subscriptions: Subscription[] = [];
  @ViewChild("metodosPagamento") metodoPagamento: MetodosPagamentosComponent;
  @Output() onSave = new EventEmitter();

  constructor(
    injector: Injector,
    public bsModalRef: BsModalRef,
    private readonly _custoAdicionalService: CustoAdicionalMensalServiceProxy,
    private readonly _assinaturaService: AssinaturaServiceProxy,
  ) {
    super(injector)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }


  protected save(): void {
    this.pagamentoSelecionado = this.metodoPagamento.pagamentoSelecionado;
    this.endereco = this.metodoPagamento.endereco;
    this.cartaoCredito = this.metodoPagamento.cartaoCredito;
    if (!this.pagamentoSelecionado) {
      abp.notify.info("Selecione a forma de pagamento!");
      return;
    }

    if (this.pagamentoSelecionado == "CARTAO" && this.validarCartao()) return;
    if (this.pagamentoSelecionado == "BOLETO" && this.validarEndereco()) return;
    abp.ui.setBusy();

    this.setFormaPagamento();

    if (this.pagamentoSelecionado === "CARTAO") {
      this.getDadosCartao()
        .then((sucesso) => {
          if (sucesso) {
            this.create();
          } else {
            abp.notify.info("Verifique os dados do cartão!");
          }
        })
        .catch((erro) => {
          console.error('Erro geral ao obter dados do cartão:', erro);
        });
    } else {
      this.create();
    }
  }

  private create():void{
    abp.ui.setBusy();
    this.createPagamento.custoAdicionalId = this.custo.id;
    this._custoAdicionalService.criarPagamento(this.createPagamento).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.custo = result;
      this.onSave.emit();
    });
  }

  private setFormaPagamento(): void {
    if (this.pagamentoSelecionado == "PIX") this.createPagamento.tipoPagamento = TipoPagamentoEnum._0
    else if (this.pagamentoSelecionado == "BOLETO") this.createPagamento.tipoPagamento = TipoPagamentoEnum._1
    else if (this.pagamentoSelecionado == "CARTAO") this.createPagamento.tipoPagamento = TipoPagamentoEnum._2

    this.createPagamento.cartaoCredito = new CartaoCreditoDto({
      cardToken: "",
      cpf: "",
      emissor: "",
      nome: "",
    });
  }


  protected validarCartao() {
    const validations = [
      { condition: StringUtils.isNullOrEmpty(this.cartaoCredito.ccv), message: "Informe o ccv do cartão!" },
      { condition: StringUtils.isNullOrEmpty(this.cartaoCredito.cpf), message: "Informe o cpf!" },
      { condition: StringUtils.isNullOrEmpty(this.cartaoCredito.nome), message: "Informe o nome!" },
      { condition: StringUtils.isNullOrEmpty(this.cartaoCredito.numeroCartao), message: "Informe o número do cartão!" },
      { condition: StringUtils.isNullOrEmpty(this.cartaoCredito.validade), message: "Informe a vaidade do cartão!" },
    ];
    this.showErrorMenssage(validations);
    return validations.some(x => x.condition);
  }

  protected validarEndereco() {
    const validations = [
      { condition: StringUtils.isNullOrEmpty(this.endereco.zipCode), message: "Informe o cep!" },
      { condition: StringUtils.isNullOrEmpty(this.endereco.city), message: "Informe a cidade!" },
      { condition: StringUtils.isNullOrEmpty(this.endereco.federalUnit), message: "Informe o estado!" },
      { condition: StringUtils.isNullOrEmpty(this.endereco.neighborhood), message: "Informe a rua!" },
      { condition: StringUtils.isNullOrEmpty(this.endereco.streetName), message: "Informe o nome da rua!" },
      { condition: StringUtils.isNullOrEmpty(this.endereco.streetNumber), message: "Informe o número!" },
    ];
    this.showErrorMenssage(validations);
    return validations.some(x => x.condition);
  }

  private showErrorMenssage(validations): void {
    for (const validation of validations) {
      if (validation.condition) {
        abp.notify.warn(validation.message);
      }
    }
  }

  private getDadosCartao(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let mes = '';
      let ano = '';

      if (this.cartaoCredito.validade && this.cartaoCredito.validade.length === 4) {
        mes = this.cartaoCredito.validade.substring(0, 2);
        ano = this.cartaoCredito.validade.substring(2, 4);
      }

      this.saving = true;
      abp.ui.setBusy();

      const subA = this._assinaturaService.getBanderiaCartao(this.cartaoCredito.numeroCartao.substring(0, 6)).pipe(
        finalize(() => {
          abp.ui.clearBusy();
          this.saving = false;
        })
      ).subscribe({
        next: (result) => {
          if (result) {
            this.createPagamento.cartaoCredito.emissor = result;

            const subB = this._custoAdicionalService.getTokenCartao(
              this.cartaoCredito.nome,
              this.cartaoCredito.cpf,
              this.cartaoCredito.numeroCartao,
              Number(mes),
              Number(`20${ano}`),
              this.cartaoCredito.ccv
            ).pipe(
              finalize(() => {
                this.saving = false;
                abp.ui.clearBusy();
              })
            ).subscribe({
              next: (token) => {
                if (token) {
                  this.createPagamento.cartaoCredito.cardToken = token;
                  this.createPagamento.cartaoCredito.nome = this.cartaoCredito.nome;
                  this.createPagamento.cartaoCredito.cpf = this.cartaoCredito.cpf;

                  resolve(true);
                } else {
                  resolve(false);
                }
              },
              error: (err) => {
                console.error('Erro ao obter token do cartão:', err);
                reject(err);
              }
            });

            this.subscriptions.push(subB);
          } else {
            resolve(false);
          }
        },
        error: (err) => {
          console.error('Erro ao obter bandeira do cartão:', err);
          reject(err);
        }
      });

      this.subscriptions.push(subA);
    });
  }

   protected getStatus() {
    switch (this.custo.status) {
      case 'pending':
        return 'Pendente';
      case 'approved':
        return 'Aprovada';
      case 'authorized':
        return 'Autorizada';
      case 'in_process':
        return 'Em Processamento';
      case 'in_mediation':
        return 'Em Mediação';
      case 'rejected':
        return 'Rejeitada';
      case 'cancelled':
        return 'Cancelada';
      case 'refunded':
        return 'Devolvida';
      case 'charged_back':
        return 'Cobrado de Volta';
      default: return "-"
    }
  }
}
